var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-729c05c240c4bdb47b03ac81d9945bfe.svg",
    clipPath: "url(#clip0_999_879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 319
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Brands"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Container",
    d: "M28.9309 0.934814H3.60531C2.17075 0.934814 1.00781 2.09775 1.00781 3.53231V18.4679C1.00781 19.9025 2.17075 21.0654 3.60531 21.0654H28.9309C30.3655 21.0654 31.5284 19.9025 31.5284 18.4679V3.53231C31.5284 2.09775 30.3655 0.934814 28.9309 0.934814Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.649375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.30229 8.29139C3.62286 7.91873 2.84743 7.61902 1.98047 7.41104L2.01683 7.24907H5.57149C6.0533 7.26596 6.44426 7.41092 6.57148 7.9229L7.344 11.606L7.58066 12.7153L9.74435 7.24907H12.0806L8.60784 15.2567H6.27149L4.30229 8.29139ZM13.7991 15.2652H11.5897L12.9716 7.24907H15.1808L13.7991 15.2652ZM21.8082 7.44504L21.5077 9.17603L21.3079 9.09091C20.9081 8.92882 20.3804 8.76685 19.6621 8.78397C18.7899 8.78397 18.3987 9.13341 18.3896 9.47457C18.3896 9.84986 18.8628 10.0972 19.6356 10.464C20.9085 11.0353 21.4989 11.7345 21.4901 12.6471C21.4722 14.3101 19.963 15.3847 17.6448 15.3847C16.6536 15.3761 15.6989 15.1795 15.1807 14.958L15.4899 13.1586L15.7808 13.2867C16.4991 13.5854 16.9717 13.7131 17.8538 13.7131C18.4899 13.7131 19.1719 13.4655 19.1806 12.9285C19.1806 12.5788 18.89 12.3228 18.0352 11.9305C17.1989 11.5466 16.0808 10.9071 16.0989 9.75578C16.1083 8.19526 17.6448 7.10376 19.8266 7.10376C20.6812 7.10376 21.3724 7.28284 21.8082 7.44504ZM24.7446 12.4254H26.581C26.4902 12.0246 26.0718 10.1058 26.0718 10.1058L25.9174 9.41507C25.8083 9.7135 25.6175 10.1996 25.6267 10.1825C25.6267 10.1825 24.9266 11.9649 24.7446 12.4254ZM27.4718 7.24907L29.2542 15.2651H27.2086C27.2086 15.2651 27.0084 14.3441 26.9449 14.0626H24.1083C24.0263 14.2757 23.6446 15.2651 23.6446 15.2651H21.3264L24.6081 7.91417C24.8355 7.39392 25.2359 7.24907 25.7629 7.24907H27.4718Z",
    fill: "#1434CB"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.17,
    height: 20.78,
    fill: "white",
    transform: "translate(0.683594 0.610107)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.760544e06a7a6cdd411df7f164737084.svg";
export { ForwardRef as ReactComponent };